import React, { useEffect, useState } from 'react';
import LoadingOverlay from 'react-loading-overlay';
import { commonConstant } from '../../../common';
import { CreateOrders } from '../../../services/promotion/payment.service';
import {
    getPriceFormat, isCartABOMemberType, message
} from '../../../services/promotion/utils.service';
import '../../promotion/CartPromotion.scss';
import { liffGetProfile } from '../../../services/promotion/auth.service';
import CustomSweetAlert from '../../../common/customSweetAlert/CustomSweetAlert';
import { SESSION_KEY, ERROR_CODES } from '../../../common/commonConstant';
import { useHistory, useLocation } from 'react-router-dom';

const { liff } = window;

export const AddressFooter = ({ cart, isInstallment, customerData, haveAddress, openSummary, disablePayment }) => {
    const [loading, setLoading] = useState(false);
    const [amwayValue, setAmwayValue] = useState({
        pointValue: 0,
        businessVolume: 0,
    });
    const history = useHistory();
    const location = useLocation();
    const [cartData, setCartData] = useState(null);
    const [isAboCart, setIsAboCart] = useState(false);

    useEffect(() => {
        const myCart = cart ? cart[0] : null;
        if (myCart) {
            setAmwayValue(myCart.amwayValue);
        }
        if (cart) {
            const accountType = cart[0]?.account?.accountType ?? '';
            const isABOMemberType = isCartABOMemberType(accountType);
            if (isABOMemberType) {
                setIsAboCart(true);
            }
        }
    }, [cart]);

    useEffect(() => {
        let cartDataLocal = JSON.parse(sessionStorage.getItem('cartData'));
        setCartData(cartDataLocal);
    }, []);

    const onAlertConfirm = async () => {
        setLoading(true);
        const myCart = cart ? cart[0] : null;
        const { userId } = await liffGetProfile();
        const cartId = myCart?.id;
        const order = await CreateOrders(cartId, userId, isInstallment);
        if (order && !order.isNotValid) {
            localStorage.setItem('deleteIds', '[]');
            if (!isInstallment) {
                sessionStorage.setItem(SESSION_KEY.pifCartId, '');
            } else {
                sessionStorage.setItem(SESSION_KEY.zippCartId, '');
            }
            console.log("NGC_STOREFRONT_URL", process.env.REACT_APP_NGC_STOREFRONT_URL);
            const urlWithOrderId = `/?seamless=${process.env.REACT_APP_NGC_STOREFRONT_URL}/checkout-retry/${order.orderNumber}`;
            setLoading(false);
            window.open(urlWithOrderId, "_self");
        } else {
            CustomSweetAlert({
                title: "",
                text: order.th_message ?? message.error.somethingWrong,
                confirmButtonText: "ตกลง",
            });
        }
    }

    const onAlertClose = async () => {
        const urlParams = new URLSearchParams(location.search);
        history.push({ pathname: commonConstant.pathCartPromotion, search: urlParams.toString() }); 
    }

    const onPurchase = async () => {
        try {
            setLoading(true);
            if (!customerData) {
                const myCart = cart ? cart[0] : null;
                const { deliveryMethod, premiumItemSet } = myCart;

                if (!deliveryMethod.deliveryContactNumber) {
                    setLoading(false);
                    CustomSweetAlert({
                        title: "",
                        text: message.error.phoneNotFound,
                        confirmButtonText: "ตกลง",
                    });
                    return;
                }

                // const hasElligibleTargetQuantity = premiumItemSet.filter(
                //     (v) => v.elligibleTargetQty !== 0,
                // );
                // if (hasElligibleTargetQuantity) {
                //     for (const item of hasElligibleTargetQuantity) {
                //         const premiumItem = item.premiumItems;
                //         const hasFreePremiumItem = premiumItem.filter(
                //             (v) => getPriceWithoutCurrency(v.targetPrice) === 0,
                //         );
                //         if (hasFreePremiumItem.length !== 0) {
                //             setLoading(false);
                //             return CustomSweetAlert({
                //                 title: "",
                //                 text: "กรุณาเลือกรับสินค้าแถมฟรี",
                //                 confirmButtonText: "ตกลง",
                //             });
                //         }
                //     }
                // }

                const { userId } = await liffGetProfile();
                const cartId = myCart?.id;
                const order = await CreateOrders(cartId, userId, isInstallment, { enableWarning: true });
                if (order && !order.isNotValid) {
                    localStorage.setItem('deleteIds', '[]');
                    if (!isInstallment) {
                        sessionStorage.setItem(SESSION_KEY.pifCartId, '');
                    } else {
                        sessionStorage.setItem(SESSION_KEY.zippCartId, '');
                    }
                    console.log("NGC_STOREFRONT_URL", process.env.REACT_APP_NGC_STOREFRONT_URL);
                    const urlWithOrderId = `/?seamless=${process.env.REACT_APP_NGC_STOREFRONT_URL}/checkout-retry/${order.orderNumber}`;
                    setLoading(false);
                    window.open(urlWithOrderId, "_self");
                } else {
                    if (ERROR_CODES[order.errorCode]) {
                        CustomSweetAlert({
                            title: "",
                            text: ERROR_CODES.GWP_OUT_OF_STOCK,
                            showCancelButton: true,
                            confirmButtonText: "ดำเนินการต่อเพื่อสั่งซื้อ",
                            cancelButtonText: "ตรวจสอบตะกร้า",
                        }, {
                            confirmButton: 'custom-swal-confirm confirm-btn-black',
                            cancelButton: 'custom-swal-confirm cancel-btn-white',
                            actions: 'custom-swal-actions with-2-btn',
                        }, onAlertConfirm, onAlertClose);
                    } else {
                        CustomSweetAlert({
                            title: "",
                            text: order.th_message ?? message.error.somethingWrong,
                            confirmButtonText: "ตกลง",
                        });
                    }
                    setLoading(false);
                }
            }
            // else {
            //   await orderFOA(cartData, customerData.uid);
            //   liff.closeWindow();
            // }
        } catch (error) {
            CustomSweetAlert({
                title: "",
                text: message.error.somethingWrong,
                confirmButtonText: "ตกลง",
            });
            console.log(error);
            setLoading(false);
        }
    };

    const onClose = () => {
        liff
            .sendMessages([
                {
                    type: 'text',
                    text: 'โปรโมชั่น',
                },
            ])
            .then(() => {
                console.log('message sent');
            })
            .catch((err) => {
                console.log('error', err);
            });
        liff.closeWindow();
    };

    const onCloseSOP = () => {
        liff
            .sendMessages([
                {
                    type: 'text',
                    text: 'SOP ของฉัน',
                },
            ])
            .then(() => {
                console.log('message sent');
            })
            .catch((err) => {
                console.log('error', err);
            });
        liff.closeWindow();
    };

    const recommendProduct = () => {
        liff
            .sendMessages([
                {
                    type: 'text',
                    text: 'สินค้าแนะนำ',
                },
            ])
            .then(() => {
                console.log('message sent');
            })
            .catch((err) => {
                console.log('error', err);
            });
        liff.closeWindow();
    };

    const getTotalPrice = () => {
        const totalPrice = cart[0]?.grandTotalPrice?.price;
        const price = getPriceFormat(totalPrice);
        return `฿ ${price}`;
    };

    return (
        <section>
            <LoadingOverlay
                text="Loading"
                spinner
                active={loading}
                styles={{ wrapper: { width: '100%', minHeight: '100%' } }}
            />
            <div className="list-address-panel-footer">
                <div className="footer-alignment">
                    <div className="price-summary-alignment">
                        <div>
                            <div className="price-text">{cart && getTotalPrice()}</div>
                        </div>
                        <div>
                            <span className="link-order-summary-text" onClick={() => openSummary(true)}>รายละเอียดคำสั่งซื้อ</span>{` >`}
                        </div>
                    </div>
                    <button
                        className="list-select-address-footer font-larger"
                        onClick={(e) => {
                            if (disablePayment) return;
                            return !haveAddress
                                ? CustomSweetAlert({
                                    title: "",
                                    text: "กรุณาเพิ่มที่อยู่จัดส่ง",
                                    confirmButtonText: "ตกลง",
                                })
                                : customerData && cartData
                                    ? onPurchase()
                                    : !customerData
                                        ? onPurchase()
                                        : (window.location.href = commonConstant.pathFOARegister);
                        }}
                        disabled={disablePayment}
                    >
                        <span className="select-address-text">สั่งซื้อ</span>
                    </button>
                </div>
            </div>
        </section>
    );
};

export default AddressFooter;
